import React, { useEffect } from 'react';
import "./styles.css";
import { CategoriesSection } from './sections/categories-section';
import { Navigation } from './sections/navigation';
import { HeroSection } from './sections/hero-section';
import { HowItWorksSection } from './sections/how-it-works-section';
import { TestimonialsSection } from './sections/testimonials-section';
import { ProfessionalsSection } from './sections/professionals-section';
import { JoinSection } from './sections/join-section';
import { FooterSection } from './sections/footer-section';
import { useDispatch } from "react-redux";
import { setCurrentLocation } from "@/redux/auth/auth.slice";
import Header from '@/layouts/Header/Header';
import { RequirementsSection } from './sections/requirements-section';

export default function HomePage() {  

  const dispatch = useDispatch();
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          dispatch(
            setCurrentLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            })
          );
          const locationData = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          localStorage.setItem("selectedVendorLocation", JSON.stringify(locationData)); 
        },
        (err) => console.error("Geolocation error:", err)
      );
    }
  }, [dispatch]);

  return (
    <>
      {/* <Navigation /> */}
      <Header/>
      <HeroSection />
      <CategoriesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <ProfessionalsSection />
      <RequirementsSection />
      <JoinSection />
      <FooterSection />
    </>
  );
}
